import { KeyboardArrowDown } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Drawer,
  Typography,
} from '@mui/material'
import { lightBlue } from 'src/utils/colors'
import { navItems } from './enums'
import NavItem from './NavItem'

interface propTypes {
  openedSidebar: boolean
  closeSidebarHanlder: () => void
}
const Sidebar: React.FC<propTypes> = (props) => {
  const { openedSidebar, closeSidebarHanlder } = props
  return (
    <Drawer
      anchor="left"
      variant="temporary"
      open={openedSidebar}
      onClose={closeSidebarHanlder}
      PaperProps={{
        sx: {
          top: '55px',
          width: 250,
          boxShadow: 'none',
          borderRight: `1px solid ${lightBlue}`,
          p: 2,
        },
      }}
      sx={{ top: '56px' }}
      BackdropProps={{ sx: { top: '56px' } }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: 'fit-content',
          justifyContent: 'start',
          pr: 1,
          pl: 0,
          '> .active li': {
            borderBottom: `2px solid ${lightBlue}`,
          },
          '> a': {
            mb: 0.5,
            maxWidth: 'fit-content',
          },
        }}
      >
        {navItems.map((item, index) => {
          if (item.id) {
            return (
              <Accordion
                sx={{
                  p: 0,
                  flexDirection: 'start',
                  '&.Mui-expanded': {
                    marginBottom: '20px !important',
                  },
                }}
                elevation={0}
                key={index}
              >
                <AccordionSummary
                  sx={{
                    px: 0,
                    py: '6px',
                    maxHeight: 'fit-content',
                    minHeight: 'initial',
                    '&.Mui-expanded': {
                      m: 0,
                      minHeight: 'initial',
                      '> div': {
                        m: 0,
                      },
                    },
                    ' > div': {
                      m: 0,
                    },
                  }}
                  expandIcon={<KeyboardArrowDown />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography
                    sx={{ pr: 2, color: lightBlue, letterSpacing: '1.8px' }}
                  >
                    {item.title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{ p: 0, pl: 1, '> a > li': { fontSize: 'small' } }}
                >
                  {item.submenu.map((item, index) => (
                    <NavItem
                      path={item.path}
                      onClick={closeSidebarHanlder}
                      key={index}
                    >
                      {item.title}
                    </NavItem>
                  ))}
                </AccordionDetails>
              </Accordion>
            )
          } else {
            return (
              <NavItem
                path={item.path}
                onClick={closeSidebarHanlder}
                key={index}
              >
                {item.title}
              </NavItem>
            )
          }
        })}
      </Box>
    </Drawer>
  )
}

export default Sidebar
